import { Box, CircularProgress, FormControl, FormHelperText, InputLabel } from '@mui/material';
import { isEmpty } from 'es-toolkit/compat';
import React from 'react';
import Dropdown, { DropdownProps } from './Dropdown';

interface Props<Multiple extends boolean = false> extends DropdownProps<Multiple> {
  label: React.ReactNode;
  className?: string;
  helperText?: string;
  error?: boolean;
  required?: boolean;
  dataTestId?: string;
  disabled?: boolean;
  loading?: boolean;
}

const LabelledDropdown = <Multiple extends boolean = false>({
  className,
  dataTestId,
  label,
  helperText,
  error,
  required,
  loading = false,
  sx,
  ...dropdownProps
}: React.PropsWithChildren<Props<Multiple>>) => {
  const labelId = React.useId();

  return (
    <FormControl
      className={className}
      fullWidth
      error={error}
      required={!loading && required}
      size={dropdownProps.size}
      sx={sx}
      variant={dropdownProps.variant}
    >
      <InputLabel id={labelId}>
        {loading ? (
          <Box sx={{ display: 'flex' }}>
            {label} <CircularProgress sx={{ marginLeft: 7 }} color="inherit" size={20} />
          </Box>
        ) : (
          label
        )}
      </InputLabel>
      <Dropdown {...dropdownProps} label={label} labelId={labelId} dataTestId={dataTestId} />
      {!isEmpty(helperText) && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default LabelledDropdown;
